import {logLoginEvent} from '@/common/analytics-events';
import {PhoneAuthProvider, signInWithCredential} from 'firebase/auth';
import {memo} from 'react';
import {Helmet} from 'react-helmet';
import {Link, Navigate, useNavigate} from 'react-router-dom';
import MyTocaLogo from '../../../assets/img/icons/redesign-icons/mytoca-logo.svg?react';
import {StandardButton} from '../../../components/Buttons/Standard/StandardButton';
import {auth as fireBaseAuth} from '../../../firebase/config';
import {getPostLoginRedirectUri, setAccessToken, setCurrentAccountId} from '../../../user/user-utils';
import styles from '.././SignInSignUp.module.scss';
import {BasePhoneVerification} from './BasePhoneVerification';

export const PhoneSignIn = memo(() => {
  const navigate = useNavigate();

  const handleVerificationComplete = async (phoneNumber: string, verificationId: string, verificationCode: string) => {
    const credential = PhoneAuthProvider.credential(verificationId, verificationCode);
    const userCredential: any = await signInWithCredential(fireBaseAuth, credential);

    const {user} = userCredential;
    setAccessToken(user.accessToken);
    setCurrentAccountId(user.uid);

    logLoginEvent('phoneNumber', {
      userUid: user.uid,
      operationType: userCredential.operationType,
    });
    navigate(getPostLoginRedirectUri());
  };

  if (import.meta.env.VITE_PHONE_ADD_SIGN_IN_ENABLED == 'false') {
    return <Navigate to="/auth" />;
  }

  return (
    <>
      <Helmet>
        <title>MyTOCA | Sign In/Sign Up</title>
      </Helmet>

      <div className={styles.container}>
        <div className={styles.logo}>
          <Link to={'/auth'}>
            <MyTocaLogo />
          </Link>
        </div>
        <h1 className={styles.heading}>Welcome</h1>
        <h2 className={styles.subheading}>Please Log in with your MyTOCA credentials</h2>
      </div>
      <BasePhoneVerification onVerificationComplete={handleVerificationComplete} buttonText="Send Verification Code" />

      <StandardButton onClick={() => navigate('/auth')} text="Back to Sign In" variant="light" customClass="mt-8" />
    </>
  );
});

PhoneSignIn.displayName = 'PhoneSignIn';
